import React from 'react'
import './headerBlog.css';

function HeaderBlog4() {
  return (
      <section id='home' className='section_headerBlog'>
        <div className='container headerBlog_main'>

           <div className='col-lg-6 col-md-12 col-sm-12 headerBlog_wrapper'>
                <div className='headerBlogPage_info'>Published on: Sep 23, 2025</div>
          <p className='headerBlogPage_info'>Author: Ponos Technology</p>
          <h2 className='headerBlogPage_title'>Scaling Stablecoins with Confidentiality: How CryptoCPU Unlocks Enterprise Adoption through ZKP+FHE</h2>

           </div>
         
        </div>
    </section>
  )
}

export default HeaderBlog4
